import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AuthShell } from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";

export default function Register() {
  const { register, apiError } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await register(form);
      navigate("/onboarding");
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <AuthShell
      title="Start free"
      subtitle="Your growth advisor, personalized to your school"
      footer={<>Already have an account? <Link to="/login" className="text-emerald-400 hover:underline">Log in</Link></>}
    >
      <form onSubmit={submit} className="space-y-4">
        <div className="space-y-1.5">
          <Label>Your name</Label>
          <Input data-testid="register-name" value={form.name} onChange={set("name")} placeholder="Jordan" className="bg-slate-950 border-slate-700 h-11" />
        </div>
        <div className="space-y-1.5">
          <Label>Email</Label>
          <Input data-testid="register-email" type="email" value={form.email} onChange={set("email")} required className="bg-slate-950 border-slate-700 h-11" />
        </div>
        <div className="space-y-1.5">
          <Label>Password</Label>
          <Input data-testid="register-password" type="password" value={form.password} onChange={set("password")} required placeholder="Min 8 characters" className="bg-slate-950 border-slate-700 h-11" />
        </div>
        {error && <p data-testid="register-error" className="text-sm text-rose-400">{error}</p>}
        <Button data-testid="register-submit" type="submit" disabled={loading} className="w-full h-11 bg-emerald-500 hover:bg-emerald-400 text-slate-950 font-semibold">
          {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Create free account"}
        </Button>
      </form>
    </AuthShell>
  );
}
